// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `chance of winning`
};

const de_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `Gewinnchance`
};

const es_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `probabilidad de ganar`
};

const fr_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `chance de gagner`
};

const fi_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `voittomahdollisuus`
};

const hi_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `जीतने की संभावना`
};

const ja_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `勝率`
};

const nl_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `kans om te winnen`
};

const pt_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `chance de ganhar`
};

const ro_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `șansa de a câștiga`
};

const th_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `โอกาสในการชนะ`
};

const ur_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `جیتنے کا چانس`
};

const zh_hant1_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `獲勝機會`
};

const da_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `chance for at vinde`
};

const it_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `probabilità di vincere`
};

const vn_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `cơ hội chiến thắng`
};

const ko_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `당첨 확률`
};

const tr_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `kazanma şansı`
};

const lv_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `iespēja uzvarēt`
};

const ar_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `فرصة الفوز`
};

const bs_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `šanse za pobjedu`
};

const sl_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `možnost za zmago`
};

const id_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `peluang menang`
};

const sv_widget_leaderboard_chance_of_winning = /** @type {(inputs: {}) => string} */ () => {
	return `chans att vinna`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_leaderboard_chance_of_winning = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_leaderboard_chance_of_winning(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_leaderboard_chance_of_winning", locale)
	if (locale === "en") return en_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "de") return de_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "es") return es_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "fr") return fr_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "fi") return fi_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "hi") return hi_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "ja") return ja_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "nl") return nl_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "pt") return pt_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "ro") return ro_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "th") return th_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "ur") return ur_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "da") return da_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "it") return it_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "vn") return vn_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "ko") return ko_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "tr") return tr_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "lv") return lv_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "ar") return ar_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "bs") return bs_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "sl") return sl_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "id") return id_widget_leaderboard_chance_of_winning(inputs)
	if (locale === "sv") return sv_widget_leaderboard_chance_of_winning(inputs)
	return "widget_leaderboard_chance_of_winning"
};